import { computed } from 'vue'
import store from '@/store'

export const propertyContact = computed(() => {
  // return property phone number if available, otherwise return a default contact email
  return store.getters['bookings/booking']?.propertyPhoneNumber || 'reservation@section-l.co'
})